<template>
  <div class="father-tree-wrapper" v-loading="loadTree">
    <div
      class="has-no-father-tree"
      v-if="hasNoFatherTree"
      v-html="hasNoTreeHtml"
    ></div>
    <div id="father" class="father-tree-container">
      <!-- <canvas id="canvasForFather"></canvas> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../../utils/apiMap";
// import { birthToDate, formatDeadKey } from "../../../utils/feed";
import $ from "jquery";
import _ from "lodash";
import dTree from "../../../utils/dTree";
import * as d3 from "d3";
export default {
  name: "father-tree",
  data() {
    return {
      loadTree: true,
      boxWidth: 80,
      boxHeight: 30,
      fatherDivPad: 30,
      fatherDivWidth: 832,
      fatherDivHeight: 92,
      motherDivWidth: 832,
      motherDivHeight: 92,
      boxMargin: 11,
      mateScale: 15,
      husbandScale: 2,
      removeNode: [], //手动添加且没孩子的节点
      parentPosition: {},
      unbindRelation: {}, //可断连的节点
      Ancestors: {},
      Descendant: {},
      copyMark: {},
      liveUser: {},
      maleMembers: {}, //直系长辈
      treeData: {},
      everyGeneLinealNode: {}, //每一代直系节点
      ancestorNode: [], //祖先节点
      personMap: {},
      hasNoFatherTree: false,
      hasNoTreeHtml: "",
      svgStyle: {
        height: 600,
        width: 840,
      },
    };
  },
  computed: {
    ...mapGetters(["loadTreeTime"]),
  },
  mounted() {
    this.getFamilyTree();
    // this.$bus.$on('reload-father-tree', this.reloadFatherTree);
    this.$bus
      .$off("reload-father-tree")
      .$on("reload-father-tree", this.reloadFatherTree);
  },
  methods: {
    beArray(arr) {
      return arr instanceof Array;
    },
    reloadFatherTree(x) {
      // console.log(x)
      this.removeNode = [];
      this.parentPosition = {};
      this.unbindRelation = {};
      this.Ancestors = {};
      this.Descendant = {};
      this.copyMark = {};
      this.liveUser = {};
      this.maleMembers = {};
      this.treeData = {};
      this.personMap = {};
      $("#father svg").remove();
      this.getFamilyTree();
    },
    getFamilyTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (!loginUser) {
        console.log("未查询到登录用户！");
        return;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.treeData = response.data.result.data;
            _this.ancestorNode = response.data.result.ancestors.map((item) =>
              item.toString()
            );
            _this.loadTree = false;
            _this.initTreeData(_this.treeData, 1);
            _this.initTreeWithD3(_this.treeData);
            _this.saveWaitMember();
            _this.setMeCenter();
          } else {
            _this.hasNoTree();
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.message.includes("Network")) {
            Store.dispatch("setLoadTreeTime", 1);
            if (_this.loadTreeTime < 5) {
              window.location.reload();
            }
          }
        });
    },
    setMeCenter() {
      let meNode = document.querySelector(".is-me");
      if (!meNode.parentNode) {
        return;
      }
      let parNode = meNode.parentNode;
      let nodeX = parNode.getAttribute("x").slice(0, -2);
      let nodeY = parNode.getAttribute("y").slice(0, -2);
      const NumExp = /^(\-|\+)?\d+(\.\d+)?$/;
      if (!document.querySelector("#father")) {
        return;
      }
      let svgNode = document.querySelector("#father").children[0].children[0];
      // console.log(svgNode.getAttribute("transform").split(" "));
      let transformVal = svgNode.getAttribute("transform").split(" ");
      let translateAttr = transformVal[0];
      // let originScale = transformVal[1];
      let bracketS = translateAttr.indexOf("(") + 1;
      let bracketE = translateAttr.lastIndexOf(")");
      let aimStr = translateAttr.slice(bracketS, bracketE);
      let originTsf = aimStr.split(",");
      if (NumExp.test(nodeX) && NumExp.test(nodeY)) {
        // console.log(Number(nodeX), Number(nodeY));
        if (NumExp.test(originTsf[0]) && NumExp.test(originTsf[1])) {
          // console.log(Number(originTsf[0]));
          // let diffHeight = this.svgStyle.height-Number(nodeY);
          let newWidth = Number(originTsf[0]) - Number(nodeX) - 40;
          let halfDiffH = this.svgStyle.height / 2 - Number(nodeY);
          let newHeight = Number(originTsf[1]) - 11 + halfDiffH;
          // console.log(Number(originTsf[1]) - 11 + halfDiffH);
          // console.log(newHeight);
          // let newVal = `translate(${newWidth},${newHeight}) ${originScale}`;
          // console.log(newVal);
          // svgNode.setAttribute("transform", newVal);
          this.runToPosition(newWidth, newHeight);
        }
      } else {
        console.log("x,y 属性不符合数字类型");
      }
    },
    runToPosition(x, y) {
      // create zoom handler
      const zoom = d3
        .zoom()
        .scaleExtent([0.1, 10])
        .on("zoom", function() {
          g.attr("transform", d3.event.transform);
        });

      // create a svg
      const svg = d3.select("svg").call(zoom);

      // create svg group that holds all nodes
      const g = d3.select(svg._groups[0][0].children[0]);

      // set zoom identity
      svg.call(zoom.transform, d3.zoomIdentity.translate(x, y).scale(1));
    },
    saveWaitMember() {
      var waitMember = {
        ancestorNode: JSON.stringify(this.ancestorNode),
        maleNode: JSON.stringify(this.maleMembers),
      };
      // console.log(waitMember)
      Store.dispatch("setWaitMember", waitMember);
    },
    initTreeWithD3(treeData) {
      let _this = this;
      dTree.init(treeData, {
        target: "#father",
        debug: true,
        hideMarriageNodes: true,
        marriageNodeSize: 5,
        height: _this.svgStyle.height,
        width: _this.svgStyle.width,
        callbacks: {
          nodeClick: function(name, userId) {
            // alert('左击: ' + name);
            _this.initPersonClick(userId);
          },
          // nodeRightClick: function(name, extra) {
          // 	alert('右击: ' + name);
          // },
          textRenderer: function(name, userId, extra, textClass) {
            if (extra && extra.nickname)
              name = name + " (" + extra.nickname + ")";
            return (
              "<p align='center' class='" + textClass + "'>" + name + "</p>"
            );
          },
          marriageClick: function(extra, id) {
            alert("Clicked marriage node" + id);
          },
          marriageRightClick: function(extra, id) {
            alert("Right-clicked marriage node" + id);
          },
        },
      });
    },
    initTreeData(data, generation) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var userKey = data.userId;
      if (data.status != "1") {
        _this.maleMembers[userKey] = {
          userId: userKey,
          status: data.status,
          userName: data.userName,
          sex: data.sex,
          generation: generation,
        };
      }
      var lookIndex = _this.ancestorNode.indexOf(data.userId.toString());
      if (lookIndex != -1) {
        _this.everyGeneLinealNode[generation] = data.userId.toString();
      }
      //copyMark 复制标记
      // if (data["copyFlag"] == 1) {
      //   var markData = {
      //     copyFlag: data.copyFlag,
      //     sex: data.sex,
      //     userId: data.userId,
      //     userName: data.userName,
      //   };
      //   _this.copyMark[generation] = markData;
      // } else {
      //   _this.copyMark[generation] = {};
      // }

      if (data.partnerPublicChildren.length == 0 && data.status != "0") {
        _this.removeNode.push(data.userId);
      }

      _this.personMap[userKey] = {
        userId: userKey,
        userName: data.userName,
        sex: data.sex,
        generation: generation,
        mate: false,
        copyFlag: data.copyFlag,
        status: data.status,
      };

      for (var p = 0; p < data.partners.length; p++) {
        var spouseId = data.partners[p].userId;
        var status = data.partners[p].status;

        _this.personMap[spouseId] = {
          userId: spouseId,
          userName: data.partners[p].userName,
          sex: data.partners[p].sex,
          generation: generation,
          mate: true,
          copyFlag: 0,
          status: data.partners[p].status,
        };

        if (data.userId == loginUser.userId && data.partners[p].status != "1") {
          if (_this.beArray(data.partnerPublicChildren[p])) {
            if (data.partnerPublicChildren[p].length == 0) {
              var mate = data.partners[p].sex == 1 ? "丈夫" : "妻子";
              _this.unbindRelation[spouseId] = {
                userId: data.userId,
                status: status,
                relation: mate,
              };
            }
          }
        } else if (data.userId != loginUser.userId) {
          if (_this.beArray(data.partnerPublicChildren[p])) {
            if (data.partnerPublicChildren[p].length == 0) {
              _this.removeNode.push(spouseId);
            }
          }
        }
      }

      generation++;
      if (data.partnerPublicChildren.length !== 0) {
        for (var i = 0; i < data.partnerPublicChildren.length; i++) {
          var orderedChildren = data.partnerPublicChildren[i];
          for (var j = 0; j < orderedChildren.length; j++) {
            if (orderedChildren[j]) {
              var childKey = orderedChildren[j].userId;
              if (data.userId == loginUser.userId) {
                var relation = orderedChildren[j].sex == 1 ? "儿子" : "女儿";
                _this.unbindRelation[childKey] = {
                  userId: data.userId,
                  status: orderedChildren[j].status,
                  relation: relation,
                };
              } else {
                var childIndex = _this.ancestorNode.indexOf(
                  childKey.toString()
                );
                if (childIndex != -1) {
                  var childStatus = orderedChildren[j].status;
                  if (childStatus == 2 || childKey == loginUser.userId) {
                    var relationName = data.sex == 1 ? "父亲" : "母亲";
                    _this.unbindRelation[childKey] = {
                      userId: data.userId,
                      relation: relationName,
                      userName: data.userName,
                      status: data.status,
                    };
                  }
                }
              }
              _this.initTreeData(orderedChildren[j], generation);
            }
          }
        }
      }
    },
    initPersonClick(userId) {
      // console.log(this.personMap);
      // console.log(this.personMap[userId]);
      let userBrief = this.personMap[userId];
      if (userBrief) {
        var treeNote = {
          linealNode: JSON.stringify(this.everyGeneLinealNode),
          removeNode: JSON.stringify(this.removeNode),
          unbindNode: JSON.stringify(this.unbindRelation),
        };
        // console.log(treeNote)
        Store.dispatch("setTreeNote", treeNote);
        var linealNode = this.everyGeneLinealNode[userBrief["generation"]];
        var clickTime = Math.round(new Date() / 1000);
        var unbindFlag = this.unbindRelation[userId];
        var removeFlag = this.removeNode.indexOf(userId);
        var userInfo = {
          clickTime: clickTime,
          dataCopy: userBrief["copyFlag"],
          dataGene: userBrief["generation"],
          mate: userBrief["mate"],
          name: userBrief["userName"],
          sex: userBrief["sex"],
          linealNode: linealNode,
          removeFlag: removeFlag,
          unbindFlag: unbindFlag,
          userId: userId,
          treeType: "1",
          userType: userBrief["status"],
        };
        //临时节点
        if (userBrief["status"] == "1") {
          userInfo.action = "2";
        }
        this.$bus.$emit("switch-tree-profile", userInfo);
      }
    },
    hasNoTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (!loginUser) {
        console.log("未查询到登录用户！");
        return;
      }
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["getProfile"]["method"],
        url: apiMap["getProfile"]["url"],
        data: `token=${loginUser.token}`,
      })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            let myProfile = response.data.result.data;
            if (response.data.result.data) {
              _this.hasNoFatherTree = true;
              _this.hasNoTreeHtml =
                "<p>向亲人申请传连后，可以自动生成家谱网。</p>" +
                "<p>步骤：联系→好友→相应亲人→他 / 她的主页→申请传连。</p>" +
                "<p>已经过世或没有手机的亲人，也可以手动添加。</p>" +
                "<p>为了使家谱图真实无误，双方必须先在手机端完成<span class='validate-text'>身份认证</span>。</p>" +
                "<p>家谱图能自动向后代共享，千古流传。</p>" +
                "<p>赶快去与亲人传连吧！</p>";
              if (response.data.result.data.isValiated == 1) {
                _this.maleMembers[myProfile.userId] = {
                  userId: myProfile.userId,
                  status: 0,
                  userName: myProfile.realName || myProfile.name,
                  sex: myProfile.sex == "男" ? 1 : 2,
                  generation: 1,
                };
                _this.ancestorNode = [myProfile.userId];
                _this.saveWaitMember();
              }
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style>
/* tree-wrapper */
.father-tree-wrapper {
  min-height: 60px;
  padding: 2px;
}

#canvasForFather {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

/* father-tree-wrapper */
.tree-container .child_box {
  width: 832px;
  position: relative;
  height: 32px;
  padding: 30px 0;
  margin: 0 auto;
  white-space: nowrap;
  z-index: 3;
}

.tree-container div a {
  display: inline-block;
  width: 80px;
  height: 30px;
  margin: 0 10px;
  font-size: 14px;
  border: 1px solid #000000;
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  color: #333333;
}

.tree-container div a.is_me {
  color: #fb6161;
}

.linage {
  fill: none;
  stroke: #000;
}
.marriage {
  fill: none;
  stroke: black;
}
.marriageNode {
  background-color: black;
  border-radius: 50%;
}
.man {
  line-height: 21px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: default;
}
.woman {
  line-height: 21px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: default;
}

svg.tree-svg {
  border-style: solid;
  border-width: 1px;
  border-color: #cccccc;
}

.is-me {
  color: #fb6161;
  border-color: #000;
}

.profile-item-content .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #000;
}

.profile-item-content .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #000;
  cursor: not-allowed;
}

.has-no-father-tree {
  width: 440px;
  margin: 0 auto;
  font-size: 16px;
}

.validate-text {
  color: #ff6600;
}
</style>
